import { useShopTokenContext } from '../../Session/ShopTokenContext';
import { ModuleConfiguration } from './types';

export const useWaitForShopToken = (waitFor: ModuleConfiguration['waitFor']) => {
  const { isLoading } = useShopTokenContext();
  return Boolean(waitFor?.shopToken) && isLoading;
};
